import type { RuleSet } from 'styled-components'
import { Icon as CssModulesIcon, type IconGlyph as CssModulesIconGlyph, IconProps } from '@sunwebgroup/uds-ui/icon'
import { css, styled } from 'styled-components'

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/icon' instead.
 */
export type IconGlyph = CssModulesIconGlyph

function modSize(size: number): RuleSet<object> {
  return css`--icon-size: ${size}px;`
}

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/icon' instead.
 */
const Icon = Object.assign(
  styled(CssModulesIcon)<IconProps>``,
  { displayName: 'Icon', modSize },
)

export default Icon
